<template>
    <a-modal
        centered
        :visible="visible"
        :keyboard="false"
        :maskClosable="false"
        title="同意放款申请"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="loan-create" :rules="rules">
            <a-form-model-item label="付款截图" prop="screenshot">
                <a-upload
                    list-type="picture-card"
                    name="file"
                    :action="action"
                    :withCredentials="true"
                    :show-upload-list="false"
                    @change="(info) => on_upload_change(info, 'screenshot')"
                    :headers="{ 'x-identity': 'manager' }"
                    accept="image/png, image/jpeg"
                >
                    <img v-if="form.screenshot" :src="form.screenshot" style="width:100%" />

                    <div v-else>
                        <a-icon :type="uploading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">
                            上传
                        </div>
                    </div>
                </a-upload>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        transaction_no: null,
        screenshot: null,
    };
    import env from "../../../../../env";
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
        },
        data() {
            return {
                action: env.base_url + "service/upload",
                submitting: false,
                uploading: false,
                rules: {
                    screenshot: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    this.form.transaction_no = this.record.transaction_no;
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["loan-create"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post("/finance/audit/loan/approve", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    this.$message.success(res.message);
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            after_close() {
                this.$refs["loan-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
            on_upload_change(info, field) {
                if (info.file.status === "uploading") {
                    this.uploading = true;
                    return;
                }
                if (info.file.status === "done") {
                    this.uploading = false;
                    if (info.file.response.success) {
                        this.form[field] = info.file.response.data.url;
                    } else {
                        this.$error({
                            title: "失败",
                            content: info.file.response.message,
                        });
                    }
                } else if (info.file.status === "error") {
                    this.$message.error(`${info.file.name} 上传失败.`);
                }
            },
        },
    };
</script>
